// @flow
import React, { Fragment } from 'react'

import { PostLink, PostTitle, PostGroup } from '../scenes/feed'
import { UnstyledList, UnstyledLink } from '../components/typography'

import { worksData } from '../data/api'
import route from '../data/routes'

type Props = {
  data: Object,
}

const IndexPage = ({ data }: Props) => {
  const { allMarkdownRemark } = data
  const { edges } = allMarkdownRemark
  const Posts = edges
    .filter(edge => !!edge.node.frontmatter.date)
    .map(edge => (
      <PostLink
        key={edge.node.id}
        to={edge.node.frontmatter.path}
        title={edge.node.frontmatter.title}
        date={edge.node.frontmatter.date}
      />
    ))
  return (
    <Fragment>
      <PostGroup>
        <PostTitle>
          <UnstyledLink to={route.writing}>Writing</UnstyledLink>
        </PostTitle>
        <UnstyledList>{Posts}</UnstyledList>
      </PostGroup>
      <PostGroup>
        <PostTitle>
          <UnstyledLink to={route.works}>Works</UnstyledLink>
        </PostTitle>
        <UnstyledList>
          {worksData.map(item =>
            item.published && (
              <PostLink
                key={item.id}
                title={item.title}
                date={item.initialPostDate}
                to={item.url}
              />
            ))}
        </UnstyledList>
      </PostGroup>
    </Fragment>
  )
}

export default IndexPage

// $FlowFixMe
export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          frontmatter {
            date(formatString: "MMMM YYYY")
            path
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js